// react
import React, { useEffect, useState } from "react";

// utils
import clamp from "../../utils/Clamp";
import ForceInt from "../../utils/ForceInt";

import PropTypes from "../../lib/prop-types";

// config
import Colors from "../../constants/Colors";
// components
import Tooltip from "../Tooltip";
// import './style.scss';
import css from "./ProgressBar.module.scss";

/**
 * @deprecated Use the ProgressBar component from the py-components package instead.
 * Renders a progress bar.
 *
 * if 'fauxProgress' is true, we attempt to fake some initial progress
 */
const ProgressBar = ({
	width = null,
	height = 6,
	progress,
	striped = true,
	animated = true,
	color = Colors.blue,
	showAmount = true,
	fauxProgress = false,
	tickFrequency = 2500,
	maxFauxPercent = 15,
	FauxPercentStart = 1,
	tickAmount = 1,
	label = null,
	labelPosition = "left",
	info = null,
	fauxZero = false,
}) => {
	const intProgress = ForceInt(progress);
	const [percentState, setPercentState] = useState(fauxZero ? FauxPercentStart : 0);

	const classes = [
		css.cpProgressBar,
		striped ? css.striped : "",
		animated ? css.animated : "",
		"cp-progress-bar",
		striped ? "striped" : "",
		animated ? "animated" : "",
	];

	const tick = () => {
		const nextValue = clamp(percentState + tickAmount, 0, maxFauxPercent);
		setPercentState(nextValue);
	};

	useEffect(() => {
		let tickTimer = null;

		if (fauxProgress) {
			tickTimer = setInterval(() => tick(), tickFrequency);
		}

		return () => {
			if (tickTimer) {
				clearInterval(tickTimer);
			}
		};
	});

	const percent = intProgress === 0 ? `${percentState}%` : `${clamp(intProgress, 0, 100)}%`;

	const progressIndicator = (
		<div style={{ width: width || "auto", height }} className={classes.join(" ")}>
			<div
				className={`${css.progressFiller} progress-filler`}
				style={{ width: percent, backgroundColor: color }}
			/>
			{showAmount ? (
				<div
					className={`${css.progressAmount} progress-amount`}
					style={{ left: percent, backgroundColor: color }}
				>
					{percent}
				</div>
			) : (
				<div />
			)}
		</div>
	);

	return (
		<div className={css.progressBarContainer} data-testid="progress-bar">
			{labelPosition === "left" && label ? <span style={{ color, alignItems: "end" }}>{label}</span> : null}
			{info ? (
				<Tooltip message={info} placement="bottom">
					{progressIndicator}
				</Tooltip>
			) : (
				progressIndicator
			)}
			{labelPosition === "right" && label ? <span style={{ color }}>{label}</span> : null}
		</div>
	);
};

ProgressBar.propTypes = {
	striped: PropTypes.bool,
	animated: PropTypes.bool,
	showAmount: PropTypes.bool,
	/**
	 * If true, will actually start progress at 10%, but will still display 0%
	 */
	fauxProgress: PropTypes.bool,
	height: PropTypes.number,
	width: PropTypes.number,
	color: PropTypes.string,
	progress: PropTypes.number.isRequired,
	tickFrequency: PropTypes.number,
	maxFauxPercent: PropTypes.number,
	FauxPercentStart: PropTypes.number,
	tickAmount: PropTypes.number,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	labelPosition: PropTypes.oneOf(["left", "right"]),
	info: PropTypes.string,
};

export default ProgressBar;
